<app-img-readonly-header
  [image]="'/assets/images/cotizador/intro.jpg'"
  [alt]="'Daimler Truck'"
  [title]="'Paquetes financieros' | translate"
  [subTitle]="(financialSetup && financialSetup?.financialSetupName) ?? 'Nombre no disponible'"
  [buttonText]="'Historial' | translate"
  (buttonAction)="openModalHistory()"
  [status]="financialSetup && financialSetup?.status"
  [versions]="versions"
  [version]="version"
  (versionChange)="onVersionChange($event)"
>
  ></app-img-readonly-header
>
<app-preloader *ngIf="isLoading"></app-preloader>
<main class="main" id="compact">
  <div id="detail">
    <div class="pageWidth">
      <div class="packageInfo">
        <div class="wrapper"></div>
      </div>
      <!-- Si el paquete se encuentra rechazado incluir el motivo-->
      <div *ngIf="isRejected()" class="rejected">
        <h3>{{ 'Motivo del rechazo' | translate }}</h3>
        <p>{{ rejectionReason }}</p>
      </div>

      <div class="wrapper">
        <div class="module general readOnly">
          <h2>{{ 'Información general' | translate }}</h2>
          <div class="row description">
            <span class="type">{{ 'Descripción para el cotizador' | translate }}</span>
            <span class="value">{{ financialSetup?.financialSetupDescription }}</span>
            <span class="type">{{ 'Habilitado' | translate }}</span>
            <span class="value">{{ financialSetup?.active ? 'Si' : 'No' }}</span>
          </div>

          <!-- <div class="row">
            <span class="type">Vigente desde</span>
            <span class="value">{{
              formatDateDayAndMonthAndYear(financialSetup?.activeStartDate)
              }}</span>
            <span class="type">Vigente hasta</span>
            <span class="value">{{
              formatDateDayAndMonthAndYear(financialSetup?.activeEndDate)
              }}</span>
          </div> -->
          <div class="row">
            <span class="type">{{ 'Producto financiero' | translate }}</span>
            <span class="value">{{ formatFinancialProduct(financialSetup?.financialProduct) }}</span>
            <span class="type">{{ 'Moneda' | translate }}</span>
            <span class="value">{{ financialSetup?.currency }}</span>
          </div>
          @if (featureLoyaltyFeriaQuotation) {
            <div class="row">
              <span class="type">Paquete Loyalty</span>
              <span class="value">{{ financialSetup?.loyaltyFinancialPackage ? 'Sí' : 'No' }}</span>
            </div>
          }
          <div class="row">
            <span class="type">{{ 'Condición' | translate }}</span>
            <span class="value">{{ showClassification(financialSetup?.classification) }}</span>
            <span class="type">{{ 'Compañía' | translate }}</span>
            <span class="value">{{ formatCompanyName(financialSetup?.companyName) }}</span>
          </div>
          @if (showFinancialSetupQuoteValidityDays) {
            <div class="row">
              <span class="type">Días de vigencia de cotización</span>
              <span class="value">{{ financialSetup?.quoteValidityDays ?? '—' }}</span>
            </div>
          }
          <div class="row">
            <span class="type">{{ 'Tipo de pago' | translate }}</span>
            <span class="value">{{ getPaymentTypeSetup() }}</span>
            <span class="type">{{ 'Forma de amortización' | translate }}</span>
            <span class="value">{{ 'Nivelada' | translate }}</span>
          </div>
          <div class="row">
            <span class="type">{{ 'Enganche' | translate }}</span>
            <span class="value">{{ showDescriptionFromTaxType(financialSetup?.downPaymentTaxType) }}</span>
            <!--<span class="type">{{ 'Tipo de comisión' | translate }}</span>
            <span class="value">{{ 'Monto fijo' | translate }}</span>-->
          </div>

          <div class="row">
            @if (iCreditGlobe()) {
              <span class="type">{{ 'Balloon' | translate }}</span>
              <span class="value">
                {{ showDescriptionFromTaxType(financialSetup?.balloonType) }}:
                {{ financialSetup?.balloonPercentage }}
                @if (
                  financialSetup?.balloonType === 'INVOICE_VALUE_TAX' ||
                  financialSetup?.balloonType === 'INVOICE_VALUE_WITHOUT_TAX' ||
                  financialSetup?.balloonType === 'AMOUNT_TO_FINANCE'
                ) {
                  %
                }
              </span>
            }
          </div>

          <div class="row">
            @if (iPureLease()) {
              <span class="type">{{ 'Depósito en garantía' | translate }}</span>
              <span class="value">{{ showDescriptionFromTaxType(financialSetup?.warrantyDeposit) }}</span>
            }
            <span class="type">{{ 'Comisión por apertura' | translate }}</span>
            <span class="value">{{ 'Monto a financiar' | translate }}</span>
          </div>

          @if (isFinancialLeasing() || iPureLease()) {
            <div class="row">
              @if (iPureLease()) {
                <span class="type">{{ 'Valor residual' | translate }}</span>
                <span class="value">
                  @if (financialSetup?.warrantyType === 'DAIMLER') {
                    Monto Fijo Calculado
                  } @else {
                    {{ showResidualValueType(financialSetup?.residualValueType) }}
                  }
                </span>
              }
              @if (isFinancialLeasing()) {
                <span class="type">{{ 'Opción de compra' | translate }}</span>
                <span class="value">{{ showPurchaseOptionType(financialSetup?.purchaseOptionType) }}</span>
              }
              @if (iPureLease()) {
                <span class="type">{{ 'Tipo de garantía' | translate }}</span>
                <span class="value">{{ showWarranty(financialSetup?.warrantyType) }}</span>
              }
            </div>
          }

          <div class="row">
            <span class="type">{{ 'Subsidio' | translate }}</span>
            <span class="value">
              @if (financialSetup?.subsidyType === 'NOT_TAXED') {
                {{ showDescriptionFromTaxType(financialSetup?.subsidyType) }}
              } @else {
                {{ showDescriptionFromTaxType(financialSetup?.subsidyType) }}:
                {{ financialSetup?.subsidyValue }}
                @if (
                  financialSetup?.subsidyType === 'INVOICE_VALUE_TAX' ||
                  financialSetup?.subsidyType === 'INVOICE_VALUE_WITHOUT_TAX' ||
                  financialSetup?.subsidyType === 'AMOUNT_TO_FINANCE'
                ) {
                  %
                }
              }
            </span>
          </div>

          <h3>{{ 'Preferencias' | translate }}</h3>
          <div class="wrapperG2">
            <span *ngIf="financialSetup?.allowPaymentDay" class="value">{{ 'Permitir día de pago' | translate }}</span>
            <span *ngIf="financialSetup?.allowCapitalGrace" class="value">{{
              'Permitir gracia de capital' | translate
            }}</span>
            <span *ngIf="financialSetup?.allowInterestGrace" class="value">{{
              'Permitir interés de gracia de capital' | translate
            }}</span>
            <span *ngIf="financialSetup?.allowOpeningFee" class="value">{{
              'Modificar comisión por apertura' | translate
            }}</span>
          </div>
        </div>
        <div class="additional">
          <!-- MÓDULO FILTROS SÓLO LECTURA -->
          <div class="module filtros readOnly">
            <h2>{{ 'Filtros' | translate }}</h2>
            <div class="wrapperG2">
              <div>
                <h3>{{ 'Tipo de unidad' | translate }}</h3>
                @for (
                  productType of getUniqueProductTypes(financialSetup?.standardFinancialSetupAttributes);
                  track productType
                ) {
                  @if (productType?.type === filterTypes.PRODUCT_TYPE) {
                    <span class="description">
                      @if (productType?.partial === true) {
                        {{ showProductType(productType?.value) + ' ' + showTotalByType(productType) }}
                      } @else {
                        {{ showProductType(productType?.value) + ' (Todos)' }}
                      }
                    </span>
                  }
                }
              </div>
              <div>
                <h3>{{ 'Tipo de persona' | translate }}</h3>
                @for (personType of financialSetup?.standardFinancialSetupAttributes; track personType) {
                  @if (personType?.type === filterTypes.PERSON_TYPE) {
                    <span class="description">
                      {{ showPersonType(personType?.value) }}
                    </span>
                  }
                }
              </div>
              <div>
                <h3>{{ 'Tipo de cotizador' | translate }}</h3>
                @for (quoteType of financialSetup?.standardFinancialSetupAttributes; track quoteType) {
                  @if (quoteType?.type === filterTypes.QUOTE_TYPE) {
                    <span class="description">{{ showQuoteType(quoteType?.value) }}</span>
                  }
                }
              </div>
              <div>
                <h3>{{ 'Distribuidores' | translate }}</h3>
                @for (dealerType of financialSetup?.standardFinancialSetupAttributes; track dealerType) {
                  @if (dealerType?.type === filterTypes.DEALER_TYPE) {
                    @if (dealerType.value === DealerType.DEALER_FULL) {
                      <span class="description">{{ showDealerType(dealerType?.value) }}</span>
                    } @else {
                      <span class="description">{{
                        showDealerType(dealerType?.value) + ' ' + showTotalByDealer()
                      }}</span>
                    }
                  }
                }
              </div>
            </div>
          </div>
          <!-- MÓDULO SEGURO SÓLO LECTURA -->
          <div class="module seguro readOnly">
            <h2>{{ 'Seguro' | translate }}</h2>
            <div class="wrapperG2">
              <div>
                <h3>{{ 'Producto' | translate }}</h3>

                @for (insuranceType of getInsurancesTypeList(); track insuranceType) {
                  <span *ngIf="showProductInsurance(insuranceType)" class="description">{{
                    showProductInsurance(insuranceType)
                  }}</span>
                }
              </div>

              <!-- Sólo se muestra Seguro de vida si el producto es Crédito directo y la persona es Física -->
              <div>
                <h3>{{ 'Vida' | translate }}</h3>
                @for (insuranceType of getInsurancesTypeList(); track insuranceType) {
                  <span class="description">{{ showLifeInsurance(insuranceType) }}</span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- MÓDULO CONDICIONES SÓLO LECTURA -->
      <div class="module condiciones">
        <h2>{{ 'Condiciones' | translate }}</h2>
        <!-- Si no hay condiciones mostar div.noData -->
        <!-- <div class="noData">No hay información disponible</div> -->

        <!-- Tabla con condiciones -->
        <!-- Agregar clase readOnly -->
        <div class="customTable condiciones readOnly">
          <div class="header">
            <!-- <div class="cell habilitado"></div> -->
            <div class="cell plazo">{{ 'Plazo' | translate }}</div>
            <div class="cell engancheMin">{{ 'Enganche mínimo' | translate }}</div>
            <div class="cell engancheMax">{{ 'Enganche máximo' | translate }}</div>
            <div class="cell interes">{{ 'Interés nominal' | translate }}</div>
            <!-- <div class="cell tasa">Tasa nominal <br />del seguro</div> -->
            <div class="cell comision">{{ 'Comisión por apertura' | translate }}</div>
            <div class="cell opcion">{{ 'Opción de compra' | translate }}</div>
            <div class="cell deposito">{{ 'Depósito en garantía' | translate }}</div>
            <div class="cell gracia">{{ 'Períodos de gracia' | translate }}</div>
          </div>

          @for (financialCondition of financialSetup?.financialConditions; track financialCondition) {
            <div class="row">
              <div class="cell plazo">{{ financialCondition?.term }}</div>
              <div class="cell engancheMin">{{ financialCondition?.minDownPaymentPercentage }}%</div>
              <div class="cell engancheMax">{{ financialCondition?.maxDownPaymentPercentage }}%</div>
              <div class="cell interes">{{ financialCondition?.nominalRate }}%</div>
              <!-- <div class="cell tasa">{{ financialCondition?.nominalRate }} %</div> -->
              <div class="cell comision">{{ financialCondition?.openingFeePercentage }} %</div>
              <div class="cell opcion">{{ financialCondition?.purchasePercentage }} %</div>
              <!-- <div class="cell incentivo">6%</div> -->
              <div class="cell deposito">
                {{ financialCondition?.warrantyDepositPercentage }}
              </div>
              <div class="cell gracia">{{ financialCondition?.gracePeriod }} {{ 'meses' | translate }}</div>
            </div>
          }
        </div>
      </div>

      <div class="actions">
        <div class="wrapper">
          <button (click)="back()" type="button" class="secondary">
            {{ 'Volver' | translate }}
          </button>
          @if (isApprovedStatus() || isDraftStatus() || isRejected()) {
            <button (click)="edit()" type="button" class="secondary">
              {{ 'Editar' | translate }}
            </button>
          }
          @if (showActions()) {
            <button (click)="openModalRejection(financialSetup)" type="button" class="secondary">
              {{ 'Eliminar' | translate }}
            </button>
          }
          @if (isApprovedStatus() && !hasNextVersion()) {
            <button
              type="button"
              (click)="createNewVersion(financialSetup.id)"
              tp="Al crear una nueva versión del Paquete Financiero podrá editarla completamente. La versión actual seguirá disponible hasta que la nueva versión sea aprobada."
              class="secondary"
            >
              {{ 'Crear nueva versión' | translate }}
            </button>
          }
          @if (canShowRequestButton()) {
            <button (click)="request()" type="submit" class="primary" [disabled]="!hasConditions()">
              {{ 'Solicitar aprobación' | translate }}
            </button>
            <span *ngIf="!hasConditions()" class="error">
              {{ 'Para solicitar aprobación, se debe ingresar al menos una condición.' | translate }}
            </span>
          }
          @if (isSupervisorRole() && isInApprovalStatus()) {
            <button (click)="openModalConfirmation()" type="submit" class="primary">
              {{ 'Rechazar' | translate }}
            </button>
            <button (click)="approve()" type="submit" class="primary">
              {{ 'Aprobar' | translate }}
            </button>
          }
        </div>
      </div>
      <!-- CONTENIDO PARA MODAL MOTIVO DEL RECHAZO -->
      <ng-template #modalTemplateConfirmation>
        <div class="modal">
          <a class="close" (click)="close()">{{ 'Cerrar' | translate }}</a>
          <h1>{{ 'Rechazar paquete financiero' | translate }}</h1>
          <div class="motivoRechazo">
            <form>
              <div class="controlWrapper">
                <label>{{ 'Motivo del rechazo' | translate }}<span class="required">*</span></label>
                <textarea rows="4" [(ngModel)]="motive"> </textarea>
              </div>
              <div class="actions">
                <div class="wrapper">
                  <button type="button" class="secondary" (click)="close()">
                    {{ 'Cancelar' | translate }}
                  </button>
                  <button type="submit" class="primary" (click)="reject()">
                    {{ 'Rechazar' | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </ng-template>
      <ng-template #modalTemplateRejection>
        <app-template-confirmation
          [title]="title"
          [subtitle]="subtitle"
          [btn1]="btn1"
          [btn2]="btn2"
          (closeModal)="close()"
          (actionBtn2)="remove()"
        ></app-template-confirmation>
      </ng-template>
    </div>
  </div>
</main>
<ng-template #modalTemplateHistory>
  <app-template-history [data]="financialSetupHistory" [btn1]="'Cerrar'" (closeModal)="close()"></app-template-history>
</ng-template>
